<template>
    <div>

        <PageHeader>
            <template v-if="id">{{ $t('group') }}</template>
            <template v-else>{{ $t('addNew') }}</template>
            <template v-if="item && item.name">: "{{ item.name }}"</template>
            <template #side>
                <ButtonIcon :to="parentRoute">
                    {{ $t('goBack') }}
                </ButtonIcon>
            </template>
        </PageHeader>

        <ErrorMessage :value="error" :dismissible="false" />

        <Form />

        <template v-if="id">

            <Products />

            <Categories />

            <ModalAddCategoriesProducts />

        </template>

    </div>
</template>



<script>
    import Form from './parts/Form.vue';
    import Products from './parts/Products.vue';
    import Categories from './parts/Categories.vue';
    import ModalAddCategoriesProducts from './parts/ModalAddCategoriesProducts.vue';

    export default {
        name: 'ProductGroupsEdit',
        components: {
            Form,
            Products,
            Categories,
            ModalAddCategoriesProducts,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                id: null,
                requestGroups: this.$req('producerProductGroups/groups'),
            };
        },
        computed: {
            parentRoute() {
                return this.$route.params.parentUrl ? this.$router.resolve(this.$route.params.parentUrl).resolved : this.$route.matched.slice(-2)[0];
            },
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            item() {
                return this.requestGroups.getData();
            },
            error() {
                return this.requestGroups.getError();
            },
            loading() {
                return this.requestGroups.getLoading();
            },
        },
        watch: {
            '$route.params.id': {
                immediate: true,
                handler(id) {
                    this.id = Number.parseInt(id) || null;
                },
            },
            spaceId() {
                this.$router.replace(this.parentRoute);
            },
        },
        methods: {
            fetchData() {
                return this.requestGroups.get({ urlParams: { id: this.id } });
            },
            showModal() {
                this.$root.$emit('bv::show::modal', 'modal-add-categories-products');
            },
        },
        created() {
            if (this.id) {
                this.fetchData();
            }
        },
    };
</script>
